import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trRef", "requiredRowProps", "row", "rowId", "selectable"];
import { c as _c } from "react-compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultRowComponent = t0 => {
  const $ = _c(8);
  let requiredRowProps;
  let rest;
  let trRef;
  if ($[0] !== t0) {
    const {
        trRef: t1,
        requiredRowProps: t2
      } = t0,
      t3 = _objectWithoutPropertiesLoose(t0, _excluded);
    trRef = t1;
    requiredRowProps = t2;
    rest = t3;
    $[0] = t0;
    $[1] = requiredRowProps;
    $[2] = rest;
    $[3] = trRef;
  } else {
    requiredRowProps = $[1];
    rest = $[2];
    trRef = $[3];
  }
  let t1;
  if ($[4] !== requiredRowProps || $[5] !== rest || $[6] !== trRef) {
    t1 = /*#__PURE__*/_jsx("tr", Object.assign({}, requiredRowProps, {
      ref: trRef
    }, rest));
    $[4] = requiredRowProps;
    $[5] = rest;
    $[6] = trRef;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};